<template>
  <div>
    <b-loading :active="loading" />
    <b-table
      :data="records"
      :mobile-cards="false"
      hoverable
      scrollable
    >
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="id"
        header-class="is-size-7 px-4 py-2"
        label="No."
        width="60px"
        v-slot="props"
      >
        {{ props.index + 1 }}.
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="serial"
        header-class="is-size-7 px-4 py-2"
        label="人員編號"
        width="104px"
        v-slot="props"
      >
        {{ props.row.serial }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="account"
        header-class="is-size-7 px-4 py-2"
        label="帳號"
        width="104px"
        v-slot="props"
      >
        {{ props.row.account }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="name"
        header-class="is-size-7 px-4 py-2"
        label="姓名"
        width="104px"
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="department"
        header-class="is-size-7 px-4 py-2"
        label="部門"
        width="104px"
        v-slot="props"
      >
        {{ props.row.department }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="ext"
        header-class="is-size-7 px-4 py-2"
        label="分機/電話"
        width="104px"
        v-slot="props"
      >
        {{ props.row.ext }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-3"
        centered
        field="orderCount"
        header-class="is-size-7 py-2"
        label="訂單數"
        width="104px"
        v-slot="props"
      >
        {{ props.row.orderCount }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="receivingCount"
        header-class="is-size-7 px-4 py-2"
        label="已領/未領"
        numeric
        v-slot="props"
        width="104px"
      >
        <span class="text-black"
        >{{ props.row.received | commaFormat }}</span>/<span
          :class="getUnreceivedColor(props.row)"
        >{{ props.row.unreceived | commaFormat }}</span>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-3"
        centered
        field="onSiteOrderCount"
        header-class="is-size-7 py-2"
        label="現場訂單"
        width="104px"
        v-slot="props"
      >
        {{ props.row.onSiteOrderCount }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="status"
        header-class="is-size-7 px-4 py-2"
        label="付款狀態"
        width="104px"
        v-slot="props"
      >
        <span :class="{ 'text-pink-500': props.row.unpaid > 0 }">
          {{ props.row.status }}
        </span>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="total"
        header-class="is-size-7 px-4 py-2"
        label="訂購總金額"
        numeric
        v-slot="props"
        width="104px"
      >
        {{ props.row.total | commaFormat | priceFormat }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="unpaid"
        header-class="is-size-7 px-4 py-2"
        label="未付款金額"
        numeric
        v-slot="props"
        width="104px"
      >
        <span :class="{'text-pink-500': props.row.unpaid > 0 }">
          {{ props.row.unpaid | commaFormat | priceFormat }}
        </span>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="subsidyTotal"
        header-class="is-size-7 px-4 py-2"
        label="補助總金額"
        numeric
        v-slot="props"
        width="104px"
      >
         {{ props.row.subsidyTotal | commaFormat | priceFormat }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="outOfSubsidy"
        header-class="is-size-7 px-4 py-2"
        label="總自付額"
        numeric
        v-slot="props"
        width="104px"
      >
         {{ props.row.outOfSubsidy | commaFormat | priceFormat }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="action"
        header-class="is-size-7 px-4 py-2"
        label="操作"
        width="28px"
        v-slot="props"
      >
        <a
          href="#"
          @click.stop.prevent="$emit('detail', props.row.id)"
          class="has-text-light-blue"
        >
          <span class="font-small">詳情</span>
        </a>
      </b-table-column>

      <template #empty>
        <div
          v-if="!loading"
          class="
            is-align-items-center
            is-flex
            is-flex-direction-column
            is-justify-content-center
            my-5
            statistics-list__empty
          "
        >
          <span v-if="!hasDateRange" class="text-[#4F5865]">請於左上方選擇資料日期範圍</span>
          <template v-else>
            <img
              alt="Empty Statistics Image"
              class="statistics-list__empty--image"
              src="@/assets/images/empty-statistics-image.svg"
              width="376px"
            />
            <span>尚未有統計資料喔</span>
          </template>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import MemberList from './MemberList';

export default MemberList;
</script>

<style lang="scss" scoped>
@import 'MemberList';
</style>
